import { styled } from "@mui/system";

const MyHeading = styled("h1")({
  padding: "0",
  margin: "0",
  marginBottom: "5px",
  fontSize: "2.5rem",
  textAlign: "center",
  background: "linear-gradient(to right, #FF6B6B 0%, purple 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontFamily: "Gloria Hallelujah",
});

export default MyHeading;
